import { render, staticRenderFns } from "./HeaderTabs.vue?vue&type=template&id=bd06f510"
import script from "./HeaderTabs.vue?vue&type=script&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&lang=js"
import style0 from "./HeaderTabs.vue?vue&type=style&index=0&id=bd06f510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports